import React from 'react';

export const getFormula = (formula = '') => {
  const re = /([A-Z][a-z]?)(\d+(\.\d+)?)/g
  return <span dangerouslySetInnerHTML={{__html: formula.replace(re,'$1<sub>$2</sub>')}}/>
}



// WEBPACK FOOTER //
// ./src/helpers/lib.js